import { createFileRoute } from "@tanstack/react-router"

import { SiftUsageView } from "@/features/sift/components/sift-usage-view"

export const Route = createFileRoute("/_shell/sift/usage/")({
  component: SiftUsageView,
})
